<template>
  <iframe
    :src="props.iframeSrc"
    ref="storiesIframe"
    allow="web-share"
    height="425px"
    width="100%"
    id='cnc-stories-iframe'
  />
</template>
<script setup lang="ts">
import {ref} from "vue";

const props = defineProps({
  iframeSrc: {type: String, required: true}
})
const storiesIframe = ref(null)

const { $event } = useNuxtApp()

const lastPosition = ref(null)

onMounted(() => {
  setInterval(() => {
    // @ts-ignore: Unreachable code error
    const position = storiesIframe?.value?.style?.position
    if (position !== lastPosition.value) {
      lastPosition.value = position
      useEvent('stories-content:fullscreen', position && String(position).toUpperCase() === 'FIXED')
    }
  }, 100)
})
</script>
<style lang="scss" scoped>
iframe {
  border: none;
}
</style>